@use '@design/design-tokens/typography/typography' as *;

.cardWrapper {
  padding: 12px;
  padding-left: 4px;
  background-color: var(--surface-default);
  display: flex;
  justify-content: space-between;
  gap: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }

  &.dragging {
    opacity: 0.5;
  }
}

.favicon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  min-width: 0;

  &.onlyUrl {
    align-items: center;
  }
}

.infoWrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.title {
  @include typography-v2-body-base;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.url {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dragHandle {
  display: flex;
  align-items: center;
  cursor: grab;
  color: var(--text-soft);
  padding: 4px;
  margin: -4px;

  &:active {
    cursor: grabbing;
  }

  &:hover {
    color: var(--text-default);
  }
}
